import DiscountRateAPI from "../api/DiscountRateAPI";

export default {
  async loadAllDiscountRates({commit}) {
    const response = await new DiscountRateAPI().loadAllDiscountRates();
    commit("setAllDiscountRates", response);
  },

  async setDiscountRate({commit}, discountRate) {
    const response = await new DiscountRateAPI().setDiscountRate(discountRate);
    commit("addDiscountRate", response);
  },

  async editDiscountRate({commit}, discountRate) {
    const response = await new DiscountRateAPI().editDiscountRate(discountRate);
    commit("editDiscountRate", response);
  },

  async discountRateImport({commit}, data) {
    return await new DiscountRateAPI().excelImport(data);
  },
};
